<!-- eslint-disable max-len -->
<script>
// import { isEmpty } from "lodash";
import Modal from "../../../../components/Modal.vue";
import AutocompleteWithMap from "../../../../components/AutocompleteWithMap.vue";
import methods from "./methods/index.js";
import GoogleMap from "../../../../components/GoogleMap.vue";
import { post } from "@/libs/axios.js";

const {
    getExistingVenues,
} = methods;

const AdvancedAddVenue = {
    emits: ["closeAddVenueModal", "savedOrUpdatedVenueClosedModal"],
    props: {
        showAddVenueModal: {
            type: Boolean,
            default: false,
            required: true,
        },
        courseName: {
            type: String,
            default: "",
            required: true,
        },
        courseRepetition: {
            type: String,
            required: true,
        },
        course: {
            type: Object,
            required: true,
        },
        term: {
            type: Object,
            required: true,
        },
    },
    watch: {
        showAddVenueModal(newVal) {
            if (newVal === true) {
                this.$refs.childMap.manualAddress = true; // summary page only ,  hide the map
            }
        },
    },
    data() {
        return {
            showEditModal: false,
            courseObj: { title: "", recurrence: "", time: "" },
            showManualAddFormMap: true,
            existingVenues: [],
            isNewVenue: true,
            lati: 55.77582304985938,
            longi: -4.050905403411567,
            zoom: 15,
            noMovePin: true,
            showExistingVenueMap: false,
            venue: null, /* will be set when AutocompleteWithMap emits AddedVenue ) */
            showSpinner: false,
        };
    },
    name: "AdvancedAddVenue",
    components: { Modal, AutocompleteWithMap, GoogleMap },
    methods: {

        listenForNextBtnClick() {
            if (this.isNewVenue === true) {
                this.$refs.childMap.saveVenue(true); // emits "venueAdded" on sucessful form validation
                if (Object.values(this.venue).length > 0) { // only true if passes the form validation
                    // this.showManualAddFormMap = false;
                    this.saveVenue(this.venue, this.course.termdate_id);
                }
            } else {
                this.venue.venue_id = this.venue.venueId; // for consistancy
                // this.venue.from_existing_venue = true;
                this.updateVenueRelationship(this.venue, this.course.termdate_id);
            }
        },
        saveVenue(venue, termDateId) {
            const endPoint = "/api/v2/venues";
            this.requestPutPostHelper(venue, termDateId, endPoint);
        },
        updateVenueRelationship(venue, termDateId) {
            const endPoint = "/api/v2/venues_put";
            this.requestPutPostHelper(venue, termDateId, endPoint);
        },
        async requestPutPostHelper(venue, termDateId, urlToHit) {
            // eslint-disable-next-line no-param-reassign
            venue.termdate_id = termDateId;

            const data = {
                // eslint-disable-next-line object-shorthand
                venue: venue,
            };

            // const formData = new FormData();
            // const ven = JSON.stringify(venue);
            // formData.append("data", ven);

            if (!this.showSpinner) {
                this.showSpinner = true;
                const res = await post(urlToHit, data);

                if (res.data.success) {
                    this.$refs.venueModal.hideModal();
                    this.$emit("savedOrUpdatedVenueClosedModal", {
                        venueId: parseInt(res.data.data.venue_id),
                    });
                    // this.venue = null;
                    // this.showManualAddFormMap = true;

                    // reset the modal to original state after saving
                    // this.$refs.childMap.venueType = "new";
                    // this.showExistingVenueMap = false;
                    // this.isNewVenue = true;
                } else {
                    // this.formSubmited = false;
                    console.log(res.data.errors);
                    alert("Something went wrong with saving.");
                }

                this.showSpinner = false;
            }
        },
        emitCloseEvtToParent() {
            this.$emit("closeAddVenueModal");
        },
        addNewVenue(data) {
            this.venue = data;
        },
        venueTypeHasChanged(venuetypeNow) {
            if (venuetypeNow === "new") {
                this.isNewVenue = true;
            } else {
                this.isNewVenue = false;
            }
        },
        venueExistingSelectedListFor(existingV) {
            this.longi = parseFloat(existingV.lng);
            this.lati = parseFloat(existingV.lat);
            this.showExistingVenueMap = true;
        },
    },
    async mounted() {
        this.$refs.childMap.manualAddress = true;
        const allUsersVenues = await getExistingVenues();

        const existingIds = allUsersVenues.map((dropDownVenue) => dropDownVenue.venue_id);
        const venuesVueIds = this.course.venues.map((e) => e.venue_id);

        const filteredIdsOnly = existingIds.filter((e) => !venuesVueIds.includes(e));
        const finallyFiltered = [];

        filteredIdsOnly.forEach((venue) => {
            allUsersVenues.forEach((v) => {
                if (v.venue_id === venue) {
                    finallyFiltered.push(v);
                }
            });
        });

        this.existingVenues = finallyFiltered; // this users venues, not already on this course
    },
    computed: {
        getCourseObj(props) {
            const course = {
                title: `${props.courseName}`,
                recurrence: props.courseRepetition,
                time: props.term.time,
            };
            return course;
        },
    },
};

export default AdvancedAddVenue;
</script>

<template>

    <Modal
        ref="venueModal"
        v-if="showAddVenueModal"
        :show-modal="showAddVenueModal"
        @close-modal="emitCloseEvtToParent"
        modal-dialog-class="modal-add-venue"
        close-text="Cancel"
        submit-text="Save"
        close-btn-class="cancel-link-no-underline"
        submit-btn-class="modal-next-button"
        :new-header="true"
        :header-options="getCourseObj"
        :show-spinner="showSpinner"
        @submit-modal="listenForNextBtnClick">
        <h2 class="header-title">Add a venue</h2>
        <div v-if="!showManualAddFormMap" id="venue_saved_message">
            <br/>
            Your venue has been saved.
            <br/>
        </div>

        <AutocompleteWithMap
            ref="childMap"
            container-class="new-venue-container"
            :show-map="showManualAddFormMap"
            :show-enter-manually-button="false"
            :show-all-form-labels="true"
            :show-confirm-button="false"
            @venue-added="addNewVenue"
            :existing-venues="existingVenues"
            @venue-type-change="venueTypeHasChanged"
            @venue-existing-selected="venueExistingSelectedListFor"
        />

        <!--  Google map for showing existing venues so user can see / check its correct location  -->
        <div v-if="showExistingVenueMap" id="existing-venue-google-map">
            <google-map
                id="map_existing_venue"
                :lng="longi"
                :lat="lati"
                :zoom="zoom"
                :no-move-pin="noMovePin"
                class="mt-4"
            />
        </div>
    </Modal>
</template>

<style scoped>
.header-title {
    margin: 3rem 0;
    font-style: normal;
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 2.25rem;
    color: #272529;
}
</style>
